let reviewsBody = document.querySelector('#judgeme_product_reviews .jdgm-rev-widg__body')
let reviews = reviewsBody.querySelectorAll('.jdgm-rev-widg__reviews > div')
var reviewTemplate = `
        <div class="review-title" itemprop="name">[[reviewTitle]]</div>
        <div class="review-ratings">
            <div class="rating-summary item" itemprop="reviewRating" itemscope="" itemtype="http://schema.org/Rating">
                <span class="label rating-label"><span>Rating</span></span>
                <div class="rating-result" id="review_3879_vote_3879" title="100%">
                    <meta itemprop="worstRating" content="1">
                    <meta itemprop="bestRating" content="100">
                    <span>
                      [[stars]]
                    </span>
                </div>
            </div>
        </div>
        <div class="review-content-container">
            <div class="review-content" itemprop="description">[[reviewDescription]]</div>
            <div class="review-details">
                <p class="review-author"><span class="review-details-label">Review by</span> <strong
                        class="review-details-value" itemprop="author">[[reviewAutor]]</strong>&nbsp;</p>
                <p class="review-date">
                  <span class="review-details-label">Posted on</span>
                  <time class="review-details-value" itemprop="datePublished" datetime="[[reviewDate]]">
                    [[reviewDate]]
                  </time>
                </p>
            </div>
        </div>
`;
function printReviews() {
  const oldReviewList = document.getElementById('custom-review-list');
  if(oldReviewList){
    oldReviewList.remove();
  }
  const newRC = document.createElement('ol');
  newRC.id = "custom-review-list"
  newRC.classList.add('items')
  newRC.classList.add('custom-review-items');
  for(let x = 0; x < reviews.length; x++) {
    const currentReview = reviews[x];
    const title = currentReview.querySelector('.jdgm-rev__title')
    const description = currentReview.querySelector('.jdgm-rev__body')
    const author = currentReview.querySelector('.jdgm-rev__author')
    const reviewDate = currentReview.querySelector('.jdgm-rev__timestamp')
    const stars = currentReview.querySelector('.jdgm-rev__rating')
    let currentReviewTemplate = reviewTemplate;
    currentReviewTemplate = currentReviewTemplate.replaceAll('[[reviewTitle]]', title.innerHTML);
    currentReviewTemplate = currentReviewTemplate.replaceAll('[[reviewDescription]]', description.innerHTML);
    currentReviewTemplate = currentReviewTemplate.replaceAll('[[reviewAutor]]', author.innerHTML);
    currentReviewTemplate = currentReviewTemplate.replaceAll('[[stars]]', stars.innerHTML);
    currentReviewTemplate = currentReviewTemplate.replaceAll('[[reviewDate]]', reviewDate.innerHTML);
    let review = document.createElement('li')
    review.classList.add('item')
    review.classList.add('review-item')
    review.innerHTML = currentReviewTemplate;
    newRC.appendChild(review);
  }
  const reviewsContainer = document.querySelector('#judgeme_product_reviews .jdgm-rev-widg__header');
  const reviewStars = reviewsContainer.querySelector('.jdgm-row-stars');
  reviewStars.classList.add('hidden');
  reviewsContainer.insertBefore(newRC,reviewStars)
}
setTimeout(function(){printReviews()},1000);
reviewsBody.classList.add('hidden');
console.log(reviewsBody, reviews)